/**
 * Event Type Color Display Modes
 * Controls how event type colors are displayed in the calendar
 */
export const EVENT_TYPE_COLOR_MODES = {
  DOT: 'dot',           // Display color as a small dot indicator
  BACKGROUND: 'background' // Display color as background
};
